import { parseErrors } from 'helpers/parseResponseErrors';
import { Toast } from 'helpers/toast';
import { getEmailTemplates } from 'queries';
import { useQuery } from 'react-query';
import { JsonDataItem } from 'types';

function useEmailTemplates(id?: number) {
  const { data } = useQuery(['email-templates', 'task', { taskId: id }], getEmailTemplates, {
    enabled: !!id,
    onError: (error: JsonDataItem) => {
      Toast.show({ description: parseErrors(error).join(', '), type: Toast.Type.Error });
    },
  });

  return { templates: data };
}

export { useEmailTemplates };
